module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10250.8e53c878.jpg";